/*
  Converts lines like  ;Label;Value;  inside product accordion rich text
  into a 2-column key/value table. Consecutive ; lines become one table.
*/
(function () {
  var ROW_RE = /^;\s*(.+?)\s*;\s*(.+?)\s*;?\s*$/;

  function buildTables(scope) {
    var boxes = (scope || document).querySelectorAll('.accordion__content');
    Array.prototype.forEach.call(boxes, function (box) {
      if (box.dataset.rteTablesDone) return;
      box.dataset.rteTablesDone = '1';

      // metafield_tag wraps rich text in <div class="metafield-rich_text_field">;
      // descend into it so the <p>/<ul> rows are direct children we can scan.
      var target = box.querySelector(':scope > .metafield-rich_text_field') || box;

      var kids = Array.prototype.slice.call(target.children);
      var i = 0;
      while (i < kids.length) {
        if (!ROW_RE.test((kids[i].textContent || '').trim())) { i++; continue; }

        var rows = [];
        var j = i;
        while (j < kids.length) {
          var m = (kids[j].textContent || '').trim().match(ROW_RE);
          if (!m) break;
          rows.push([m[1], m[2]]);
          j++;
        }

        var table = document.createElement('table');
        table.className = 'rte-table';
        rows.forEach(function (cells) {
          var tr = document.createElement('tr');
          var key = document.createElement('td');
          key.className = 'rte-table__key';
          key.textContent = cells[0];
          var val = document.createElement('td');
          val.textContent = cells[1];
          tr.appendChild(key);
          tr.appendChild(val);
          table.appendChild(tr);
        });

        target.insertBefore(table, kids[i]);
        for (var x = i; x < j; x++) {
          if (kids[x].parentNode) kids[x].parentNode.removeChild(kids[x]);
        }
        i = j;
      }
    });
  }

  function run() { buildTables(document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', function (e) {
    buildTables(e.target);
  });
})();
